export default {
  colors: {
    primary: '#D1B374',
    background: '#FFFFFF',
    shape: `#F2F2FA`,
    title: `#3D3D4D`,
    text: `#6C6C80`,
    components: {
      blockquote: {
        background: `#332616`,
        text: `#E1E1E6`,
      },
    },
  },
  fonts: {
    fontFace: {
      family: 'sans-serif'
    },
    body: 'sans-serif',
  },
};
